/*
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:51
 * @LastEditors: chenkailun
 * @LastEditTime: 2024-10-09 17:21:02
 * @Description: 
 * @FilePath: \solarbiolite\src\store\modules\checkout.js
 */
// initial state
const state = {
  comment: '',
  score: null,
  getPayType:null,
  goBackNum:-2,
  activityModeId:0,
  exchangeInfo:[],
  checkedItem:[],
  bonusList:[],
  selectedBonus:[]
}

// mutations
const mutations = {
  saveCommentInfo(state, payload) {        
    state.comment = payload.comment
  },
  clearCommentInfo(state) {
    state.comment = ''
  },

  saveScoreInfo(state, value) {
  	state.score = value;
  },
  clearScoreInfo(state) {
    state.score = null;
  },

  //payType
  savePayType(state, value) {
    state.getPayType = value;
  },

  saveGoBackNum(state, value) {
  	state.goBackNum = value;
  },
  clearGoBackNum(state) {
    state.goBackNum = -2;
  },

  setActivityModeId(state, value) {
		state.activityModeId = value;
	},

  //换购
  setExchangeInfo(state, value) {
		state.exchangeInfo = value;
	},

  /** 结算产品信息 */
  setCheckedItem(state, value) {
		state.checkedItem = value;
	},

  saveBonusList(state, value){
    state.bonusList = value;
  },

  saveSelectedBonus(state, value){
    state.selectedBonus = value;
  }

}

export default {
  state,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/checkout.js